module.exports = __webpack_public_path__ + "img/writing.e074e89f.png";